export default class DtoQualitometerAquifer {
    constructor(obj) {
        this.idQualito = obj.idQualito
        this.idAquifer = obj.idAquifer
    }
}